import AvatarCircle from "app/components/AvatarCircle";
import { Button as ShadcnButton } from "app/shadcnComponents/ui/button";
import { ACTION_CONFIG, NonRecipientUser } from "./types";

export default function NonRecipientRow({
  user,
  onAction,
  isSaving,
  label,
  actionType,
}: Readonly<{
  user: NonRecipientUser;
  onAction?: (userAccountId: number) => void;
  isSaving: boolean;
  label: string;
  actionType?: "add" | "remove";
}>) {
  const fullName = `${user.firstName} ${user.lastName}`;
  const action = actionType ? ACTION_CONFIG[actionType] : null;

  return (
    <div className="flex gap-3 py-2.5 px-6 opacity-70 hover:bg-charcoal-02 transition-colors">
      <AvatarCircle
        name={fullName}
        userAccountId={user.userAccountId}
        size="small"
      />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-charcoal-150">{fullName}</div>
        <div className="text-xs text-charcoal-80">{user.jobTitle ?? ""}</div>
        <span className="text-[10px] font-medium text-amber-700 bg-amber-50 border border-amber-200 rounded-full px-2 py-0.5 leading-none inline-block mt-1">
          {label}
        </span>
      </div>
      {action && (
        <div className="flex-shrink-0 self-center ml-1">
          <ShadcnButton
            variant={action.variant}
            size="sm"
            onClick={() => onAction?.(user.userAccountId)}
            disabled={isSaving}
            className={action.className}
          >
            {action.label}
          </ShadcnButton>
        </div>
      )}
    </div>
  );
}
